<template>
  <div>
      <el-form :inline="true" size="small">
        <el-form-item  :label="'IMEI号'">
          <el-button  type="primary" plain >{{chuaniccid}}</el-button>
        </el-form-item>
        <el-form-item  label="主体套餐：">
          <el-button  type="primary" plain >{{chuanname}}</el-button>
        </el-form-item>
      </el-form>

      <el-form size="small" :inline="true" style="margin-top: 1%">
        <!--具体套餐-->
        <el-table
                :row-style="{height:'10px'}"
                :cell-style="{height:'5px,0',textAlign:'center'}"
                :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                :data="tableData.slice((queryParams.current-1)*queryParams.size,queryParams.current*queryParams.size)"
                :row-class-name="tableRowClass"
        >
          <el-table-column
                  min-width="70"
                  label="序号"
                  show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.$index +1 }}
            </template>
          </el-table-column>
          <el-table-column
                  min-width="70"
                  label="详情"
                  >
            <template slot-scope="scope">
              <i @click="openLog(scope.row)" style="color: #1b5eea;cursor: pointer" class="el-icon-edit"></i>
            </template>
          </el-table-column>
          <el-table-column
                  prop="ordNo"
                  label="订单"
                  min-width="150">
          </el-table-column>
          <el-table-column v-if="roleId==='777' || roleId==='619285375'"
                  min-width="180"
                  prop="packetName"
                  label="套餐名称">
          </el-table-column>
          <el-table-column v-if="roleId!='777' && roleId!='619285375'"
                  min-width="180"
                  prop="packetWxName"
                  label="套餐名称">
          </el-table-column>
          <el-table-column
                  min-width="70"
                  label="状态">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status===1 && scope.row.endTime.indexOf('1970-')==-1" size="mini" type="primary" icon="el-icon-check" circle></el-button>
              <el-button v-if="scope.row.status===0 && scope.row.endTime.indexOf('1970-')==-1" size="mini" type="danger" icon="el-icon-close" circle></el-button>
              <el-button v-if="(scope.row.status===0 && scope.row.endTime.indexOf('1970-')!==-1)||scope.row.status===66" size="mini" type="info" circle>退</el-button>
            </template>
          </el-table-column>
          <el-table-column
                  prop="trueFlow"
                  label="套餐总量(MB)"
                  min-width="100">
          </el-table-column>
          <el-table-column v-if="roleId==='777' || roleId==='619285375'"
                  min-width="100"
                  prop="errorFlow"
                  label="实际流量(MB)">
          </el-table-column>
          <el-table-column
                  min-width="150"
                  prop="startTime"
                  label="生效时间">
          </el-table-column>
          <el-table-column
                  prop="endTime"
                  label="到期时间"
                  min-width="150">
          </el-table-column>
          <el-table-column
                  min-width="150"
                  prop="createTime"
                  label="订购时间">
          </el-table-column>

          <el-table-column
                  min-width="100"
                  prop="useFlow"
                  label="累计用量(MB)">
          </el-table-column>
          <el-table-column
                  min-width="100"
                  prop="useSoFlow"
                  label="本月用量(MB)">
          </el-table-column>
          <el-table-column v-if="roleId==='777' || roleId==='619285375'"
                  min-width="70"
                  prop="errorTime"
                  label="SO">
          </el-table-column>
          <el-table-column
                  min-width="100"
                  label="订单类型">
            <template slot-scope="scope">
              <span v-if="scope.row.ordType==='month'">本月包</span>
              <span v-if="scope.row.ordType==='next'">次月包</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" prop="packet" label="套餐类型">
            <template slot-scope="scope">
              <span v-if="scope.row.packetType===0">基础包</span>
              <span v-if="scope.row.packetType===1">加油包</span>
            </template>
          </el-table-column>

        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>
      </el-form>


    <el-dialog
            :title="boxTitle"
            :visible.sync="box"
            width="75%"
            :modal-append-to-body="false"
            :append-to-body="true"
            center>

      <el-table
              @selection-change="handleChange"
              :data="glData"
              style="width: 100%">

        <el-table-column
                label="IMEI"
                width="195%"
                prop="imei"
        >
          <template slot-scope="{row}">
            <span style="color: #2573f3">{{row.imei}}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="ordNo"
                label="订单"
                min-width="90%"
        >
        </el-table-column>

        <el-table-column
                min-width="40%"
                label="状态">
          <template slot-scope="{row}">
            <el-button v-if="row.status===1" size="mini" type="primary" icon="el-icon-check" circle></el-button>
            <el-button v-if="row.status===0" size="mini" type="danger" icon="el-icon-close" circle></el-button>
            <el-button v-if="row.status===66" size="mini" type="info" circle>退</el-button>
          </template>
        </el-table-column>
        <el-table-column
                min-width="80%"
                prop="startTime"
                label="生效时间">
        </el-table-column>
        <el-table-column
                prop="endTime"
                label="到期时间"
                min-width="80%">
        </el-table-column>
        <el-table-column
                min-width="80%"
                prop="createTime"
                label="订购时间">
        </el-table-column>

        <el-table-column
                min-width="70%"
                prop="useFlow"
                label="累计用量(MB)">
        </el-table-column>
        <el-table-column
                min-width="70%"
                prop="useSoFlow"
                label="本月用量(MB)">
        </el-table-column>
        <el-table-column
                min-width="30%"
                prop="errorTime"
                label="SO">
        </el-table-column>
      </el-table>

      <div style="margin:2%;color: black;font-size: 16px;display: inline-flex"><div style="width: 3px;height: 20px;background-color: #ff4d51;margin-right: 2px"></div>关联卡 套餐</div>
      <el-table
              @selection-change="handleChange"
              :data="caData"
              style="width: 100%">

        <el-table-column

                label="ICCID"
                width="195%"
                prop="iccid"
        >
          <template slot-scope="{row}">
            <span style="color: #2573f3">{{row.iccid}}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="ordNo"
                label="订单"
                min-width="90%"
        >
        </el-table-column>

        <el-table-column
                min-width="40%"
                label="状态">
          <template slot-scope="{row}">
            <el-button v-if="row.status===1" size="mini" type="primary" icon="el-icon-check" circle></el-button>
            <el-button v-if="row.status===0" size="mini" type="danger" icon="el-icon-close" circle></el-button>
            <el-button v-if="row.status===66" size="mini" type="info" circle>退</el-button>
          </template>
        </el-table-column>
        <el-table-column
                min-width="80%"
                prop="startTime"
                label="生效时间">
        </el-table-column>
        <el-table-column
                prop="endTime"
                label="到期时间"
                min-width="80%">
        </el-table-column>
        <el-table-column
                min-width="80%"
                prop="createTime"
                label="订购时间">
        </el-table-column>

        <el-table-column
                min-width="70%"
                prop="useFlow"
                label="累计用量(MB)">
        </el-table-column>
        <el-table-column
                min-width="70%"
                prop="useSoFlow"
                label="本月用量(MB)">
        </el-table-column>
        <el-table-column
                min-width="30%"
                prop="errorTime"
                label="SO">
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
<!--          <el-button v-if="roleId==='777' || roleId==='619285375'"  @click="unscribePaket"  size="small" type="primary" plain >退订套餐</el-button>-->
<!--          <el-button v-if="roleId==='777' || roleId==='619285375'" @click="currentToNext" size="small" type="primary" plain>当转次</el-button>-->
<!--          <el-button v-if="roleId==='777' || roleId==='619285375'" @click="joinpackage"  size="small" type="primary" plain>衔接套餐</el-button>-->
          <el-button size="small" type="info" @click="box = false">取 消</el-button>
          <el-button size="small" type="success" @click="box = false">确 定</el-button>
    </span>
  </el-dialog>

    <!--退订-->
    <el-dialog :close-on-click-modal="false"  append-to-body :visible.sync="openRefund" :title="refundTitle" class="class_dialog_hospital" width="50%">
      <template>
        <el-form :model="refund" label-width="90px">
          <el-form-item v-if="actionParams.couponId!=null"label="使用卡卷 :">
            <el-input placeholder="" v-model.trim="refund.couponName" readonly="readonly" />
            <span style="color: red">*使用优惠的订单退款金额需减去优惠劵金额</span>
          </el-form-item>
          <el-form-item label="套餐售价 :">
            <el-input placeholder="" v-model.trim="refund.price" readonly="readonly" />
          </el-form-item>
          <el-form-item label="套餐成本 :">
            <el-input placeholder="" v-model.trim="refund.packetCost" readonly="readonly" />
          </el-form-item>
          <el-form-item label="退款金额 *:">
            <el-input placeholder="不能大于套餐售价" type="number"  v-model.trim="refund.rprice" />
          </el-form-item>
          <el-form-item label="备注 :">
            <el-input placeholder="自定义" v-model.trim="refund.info" maxlength="50" />
          </el-form-item>
        </el-form>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelTd">取 消</el-button>
        <el-button :disabled="show" size="small" @click="unsubscribeOK" type="primary" plain >确认</el-button>
      </div>

    </el-dialog>




    </div>
</template>

<script>

import Pagination from '../../components/pagination'

export default {
  name: 'devicePacketDescInfo',
  components: {
    Pagination
  },
  props:{
    chuaniccid: String,
    chuanname:String,
  },
  mounted: function () {
    //this.queryParams.iccid = this.$route.query.iccid
    //this.packetName = this.$route.query.packetName
    this.maxHeight = this.$listenHeight.getBodyHeight()
    this.list(1)
  },
  data() {
      return {
        roleId: this.$loginUser.roleId,
        show:false,
        section:[],
        refundTitle:'',
        refund:{
          price: 0,
          packetCost:0,
          rprice: '',
          info: '',
          couponName:''
        },
        refundData:[],
        openRefund: false,
        actionParams:{
          ordNo:'',
          price: 0,
          packetCost:0,
          couponId:'',
          couponNum:0,
          couponOrderId:0,
          minsPrice:0.0
        },
        glData:[],
        caData:[],
        boxTitle:'',
        box: false,
        package: '',
        tableData: [],
        maxHeight: '',
        devicejs: require('../../api/device'),
        packetjs: require('../../api/packet'),
        packetName: '',
        queryParams:{
          flag: '0',
          imei: this.chuaniccid,
          current: 1,
          size: 10
        }

    }
  },


  created() {

  },
  methods: {
    cancelTd(){
      let that=this
      that.openRefund = false
      that.show=false
    },
    joinpackage() {
      let that = this
      if(that.section.length === 0 || that.section.length > 1){
        that.$alert("请选择一个套餐操作")
        return false
      }
      let one = that.section[0]
      if(one.status===0){
        that.$alert("该状态不允许操作")
        return false
      }
      if(one.useSoFlow>0 || one.useFlow >0){
        that.$alert("请选择一个未使用的套餐操作")
        return false
      }
      let title = "衔接套餐"
      that.$confirm('流量包 [' + title + '] 操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
              .then(() => {
                that.show=true
                let map = {}
                map.iccid =one.iccid
                map.ordNo = one.ordNo
                map.id = one.id
                that.packetjs.join_package(map).then(response => {
                  if (response.data.code === '0') {
                    that.$alert(response.data.data)
                  } else {
                    that.$alert(response.data.msg)
                  }
                  that.box = false
                  that.list(1)
                })
              })
              .catch((err) => {
              })
    },
    currentToNext(){
      let that = this
      if(that.section.length === 0 || that.section.length > 1){
        that.$alert("请选择一个套餐操作")
        return false
      }
      let one = that.section[0]
      if(one.status===0){
        that.$alert("该状态不允许操作")
        return false
      }
      if(one.useSoFlow>0 || one.useFlow >0){
        that.$alert("请选择一个未使用的套餐操作")
        return false
      }
      let iccid = one.iccid
      let id = one.id
      let start = one.startTime
      let end = one.endTime
      let st=start.split("-")[0] + start.split("-")[1]
      let et=end.split("-")[0] + end.split("-")[1]
      if(st!==et){
        that.$alert("该周期套餐不允许操作")
        return false
      }
      that.$confirm('套餐【当月转次月】操作, 是否继续?', '提示：只允许操作月套餐', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
              .then(() => {
                that.show=true
                let map = {}
                map.iccid = iccid
                map.id =id
                this.packetjs.upd_packageTime( map).then(response => {
                  if (response.data.code === '0') {
                    that.$alert(response.data.data)
                  } else {
                    that.$alert(response.data.msg)
                  }
                  that.box = false
                  that.list(1)
                })
              })
              .catch((err) => {
                that.$alert("网络异常："+err)
              })
    },
    handleChange(section){
      this.section = section
    },
    unsubscribeOK(){
      let that = this
      if(that.refund.rprice>that.refund.price ){
        that.$alert("退款金额参数错误")
        return false
      }
      that.refund.imei = that.queryParams.imei
      that.refund.ordNo = that.actionParams.ordNo
      //执行退订
      that.show=true
      that.packetjs.unsubscribe(that.refund).then(res=>{
        if(res.data.code==='0'){
          that.$alert(res.data.data)
        }else{
          that.$alert(res.data.msg)
        }
      }).catch(err=>{
        that.$alert(err)
      })
    },
    unscribePaket() {
      //套餐退订打开窗口
      //套餐操作
      let _this = this
      _this.refund.price =_this.actionParams.price
      _this.refund.packetCost =_this.actionParams.packetCost
      if(_this.actionParams.couponId!=null){
        _this.refund.couponName=_this.actionParams.minsPrice+'*'+_this.actionParams.couponNum
      }
      _this.refundTitle='执行退订 (温馨提示：【退订套餐时请结合返佣情况合理退费】)'
      _this.openRefund = true

      },

    openLog(row){
      let that =this
      that.caData=[]
      var name=row.packetName===null?'赠送':row.packetName
      that.boxTitle = "关联订单套餐详情("+name+")"
      that.actionParams.ordNo = row.ordNo
      that.actionParams.price = row.price
      that.actionParams.packetCost=row.packetCost===null?0:row.packetCost
      that.actionParams.couponId=row.couponId
      that.actionParams.couponNum=row.couponNum
      that.actionParams.couponOrderId=row.couponOrderId
      that.actionParams.minsPrice=row.minsPrice
      that.glData = that.tableData.filter(item=>item.ordNo===row.ordNo)
      that.tableData.filter(item=>{
        if(item.ordNo===row.ordNo){
          item.children.map(i=>that.caData.push(i))
        }
      })
      that.box = true
    },
    tableRowClass({row,rowIndex}){
      if(row.status===0){
        return 'warning-row'
      }
      if(row.status===1){
        return 'success-row'
      }
      return ''
    },
    clspact(val){
      this.queryParams.flag = val
    },
    list(page){
      let _this=this
      _this.queryParams.size = _this.$refs.pagination.size
      _this.queryParams.current = page
      _this.queryflow(_this.queryParams,page)
    },
    async queryflow(map,page) {
      //查询现有流量包
      let _this = this
      let response =await  _this.devicejs.queryPackageDescInfoActive( map)
      if (response.data.code === '0') {
        _this.tableData = response.data.data.rows
        //let p = (_this.queryParams.current -1) * _this.queryParams.size
        //_this.tableData = _this.tableData.slice(p,_this.queryParams.size)
        _this.$refs.pagination.render(page,response.data.data.total)
      }

    }
  }
}
</script>

<style scoped lang="less">

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
  .el-table__body-wrapper {
    height: calc(100% - 48px) !important; // 表格高度减去表头的高度
  overflow-y: auto;
  }
  }


  .el-table .warning-row {
    background: rgba(255, 242, 223, 0.82);
  }

  .el-table .success-row {
    background: rgba(153, 233, 205, 0.67);
  }
</style>

